import api from "./api";

export const paymentService = {
  async initializeDeposit(amount) {
    const response = await api.post("/payments/deposit", { amount });
    return response.data;
  },

  async verifyPayment(reference) {
    const response = await api.get(`/payments/verify/${reference}`);
    return response.data;
  },

  async initializeKorapayDeposit(amount) {
    const response = await api.post("/payments/korapay/deposit", { amount });
    return response.data;
  },

  async verifyKorapayPayment(reference) {
    const response = await api.get(`/payments/korapay/verify/${reference}`);
    return response.data;
  },

  async initializeTransactpayDeposit(amount) {
    const response = await api.post("/payments/transactpay/deposit", {
      amount,
    });
    return response.data;
  },

  async verifyTransactpayPayment(reference) {
    const response = await api.get(`/payments/transactpay/verify/${reference}`);
    return response.data;
  },

  async getEnabledPaymentMethods() {
    const response = await api.get("/payments/methods");
    return response.data;
  },

  async purchaseAccount(accountId) {
    const response = await api.post(`/payments/purchase/${accountId}`);
    return response.data;
  },

  async getTransactions() {
    const response = await api.get("/payments/transactions");
    return response.data;
  },

  async getOrders() {
    const response = await api.get("/payments/orders");
    return response.data;
  },

  // virtual numbers
  async getCountries() {
    const response = await api.get("/virtual-numbers/countries");
    return response.data;
  },

  async getServicesByCountry(countryId) {
    const response = await api.get(
      `/virtual-numbers/countries/${countryId}/services`,
    );
    return response.data;
  },
};

export const adminPaymentService = {
  async getPaymentMethods() {
    const response = await api.get("/admin/payment-config");
    return response.data;
  },

  async updatePaymentMethod(methodName, data) {
    const response = await api.put(`/admin/payment-config/${methodName}`, data);
    return response.data;
  },

  async togglePaymentMethod(methodName) {
    const response = await api.patch(
      `/admin/payment-config/${methodName}/toggle`,
    );
    return response.data;
  },
};
